import React from 'react';
import { Loader2 } from 'lucide-react';

interface LazyRouteFallbackProps {
    compact?: boolean;
}

const LazyRouteFallback: React.FC<LazyRouteFallbackProps> = ({ compact = false }) => (
    <div
        role="status"
        aria-live="polite"
        className={`${compact ? 'h-full min-h-60' : 'min-h-screen'} flex w-full items-center justify-center bg-slate-50`}
    >
        <Loader2 className="animate-spin text-indigo-600" size={compact ? 32 : 48} aria-hidden="true" />
        <span className="sr-only">화면을 불러오는 중입니다.</span>
    </div>
);

export default LazyRouteFallback;
